










































import { Component, Vue, Watch } from 'vue-property-decorator';
import { SupplierItemDTOSupplierStatusEnum } from '@/api';
import { supplierModule } from '@/store';

@Component({
  name: 'supplier-thing',
})
export default class SupplierThing extends Vue {
  innerStatus = SupplierItemDTOSupplierStatusEnum.NONE;

  commentVisible = false;

  replacementForm = {
    link: '',
  }

  priceChanging = false;

  priceForm = {
    price: 0,
  }

  get selectedThing() {
    return supplierModule.selectedThing;
  }

  @Watch('status', { immediate: true })
  onItemChange(value: SupplierItemDTOSupplierStatusEnum) {
    this.innerStatus = value;
  }

  get status() {
    return (this.selectedThing && this.selectedThing.supplierStatus)
      || SupplierItemDTOSupplierStatusEnum.NONE;
  }

  setStatus(value: SupplierItemDTOSupplierStatusEnum) {
    this.cancel();
    if (value === SupplierItemDTOSupplierStatusEnum.RESERVED) {
      this.setReserved();
    }
    if (value === SupplierItemDTOSupplierStatusEnum.READY_FOR_DELIVERY) {
      this.setReadyForDelivery();
    }
    if (value === SupplierItemDTOSupplierStatusEnum.MISSING) {
      this.commentVisible = true;
    }
    if (value === SupplierItemDTOSupplierStatusEnum.PRICE_CHANGED) {
      this.priceChanging = true;
    }
    this.innerStatus = value;
  }

  setReserved() {
    if (this.selectedThing) {
      supplierModule.setReserved(this.selectedThing);
    }
  }

  setNewPrice() {
    const { price } = this.priceForm;
    if (this.selectedThing) {
      supplierModule.setNewPrice({ supplierItem: this.selectedThing, price });
    }
  }

  cancel() {
    this.innerStatus = this.status;
    this.commentVisible = false;
    this.priceChanging = false;
  }

  setOutOfStock() {
    const replacementLink = this.replacementForm.link;
    if (this.selectedThing) {
      supplierModule.setOutOfStock({ supplierItem: this.selectedThing, replacementLink });
    }
  }

  setReadyForDelivery() {
    if (this.selectedThing) {
      supplierModule.setReadyForDelivery(this.selectedThing);
    }
  }
}
